<template>
    <div class="custom_select" @click="focus" :class="{ focus: viewOptions }">
        <div class="custom_selected">{{ selected?.[labelKey] || "Select..." }}</div>
        <img loading="lazy" src="/arrow.svg" alt="" />

        <transition name="options-anim">
            <div v-show="viewOptions" class="custom_options">
                <div class="custom_option" :class="{ active: selected?.[valueKey] === element?.[valueKey] }"
                    v-for="element in list || []" :key="element?.[valueKey]" @click="selectedElement(element)">
                    {{ element[labelKey] }}
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import { useClickOutside } from "@/composables/useClickOutside.js";

export default {
    name: "MySelect",
    components: {},
    props: {
        list: {
            type: Array,
            required: true
        },
        modelValue: {
            type: [String, Number],
            default: ""
        },
        valueKey: {
            type: String,
            default: "value"
        },
        labelKey: {
            type: String,
            default: "label"
        }
    },
    emits: ["update:modelValue"],
    data() {
        return {
            viewOptions: false
        }
    },
    methods: {
        focus() {
            this.viewOptions = !this.viewOptions;
        },
        selectedElement(element) {
            this.$emit("update:modelValue", element[this.valueKey])
        }
    },
    computed: {
        selected() {
            if (!Array.isArray(this.list)) return null;

            return this.list.find(
                el => el[this.valueKey] === this.modelValue
            ) || null;
        }
    },
    mounted() {
        this.removeClickOutside = useClickOutside(
            this.$el,
            () => this.viewOptions = false
        );
    },
    beforeUnmount() {
        this.removeClickOutside?.();
    }
}
</script>

<style>
.custom_select {
    position: relative;
    appearance: none;
    cursor: pointer;
    border: none;
    border-radius: 15px;
    padding: 0 1rem;
    color: var(--text-color);
    width: 330px;
    display: flex;
    transition: all 0.2s ease;
    background-color: var(--text-hover-color);
    height: 43px;
    box-sizing: border-box;
    align-items: center;
}

.custom_select.focus {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}

.custom_select img {
    width: 15px;
    height: 15px;
    transition: transform 0.2s ease;
}

.custom_select.focus img {
    transform: rotate(180deg);
}

.custom_selected {
    width: 100%;
    font-size: 0.95rem;
}

.custom_options {
    position: absolute;
    bottom: 105%;
    left: 0;
    width: 100%;
    max-height: 200px;
    background-color: var(--border-color);
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    overflow-y: auto;
}

.custom_options::-webkit-scrollbar-thumb {
    background-color: rgba(104, 104, 104, 0.4);
    border-radius: 20px;
}

.custom_options::-webkit-scrollbar-track {
    margin-top: 8px;
}

.custom_option {
    color: var(--text-color);
    padding: 5px 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.custom_option.active {
    background: var(--text-hover-color);
    font-weight: 700;
}

.custom_option:hover {
    background: var(--text-hover-color);
}

.options-anim-enter-active,
.options-anim-leave-active {
    transition: all 0.2s ease;
}

.options-anim-enter-from,
.options-anim-leave-to {
    opacity: 0;
    transform: translateY(-10px);
}

.options-anim-enter-to,
.options-anim-leave-from {
    opacity: 1;
    transform: translateY(0px);
}
</style>
